import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  CalenderIcon2,
  ExclusiveIcon,
  LiveIcon,
  VipIcon,
} from "../../../../Assets/svgIcons";
import { useNavigate } from "react-router-dom";
import Countdown from "../../../../components/countdown/countdown.component";
import moment from "moment";

const PromotionsCard = ({ data, type }) => {
  const navigate = useNavigate();

  // *********** INFLUENCER NAVIGATION PROMOTIONS ***********
  const handleNavigate = (data) => {
    const detailData = {
      invitationData: data?.invitationData,
      auctionCommision: data?.auctionCommision,
    };
    navigate(`/influncer-analytics?auctionId=${data?.id}`, {
      state: detailData,
    });
  };

  const showTimeFun = (status, auctionDate) => {
    switch (status) {
      case "InProgress":
        return (
          <>
            Auction Ends in <Countdown date={auctionDate} />
          </>
        );
      case "TimeEnded":
        return `Auction Ended`;
      case "Scheduled":
        return `Scheduled ${moment(auctionDate).format("MMM D YYYY")}`;
      case "Completed":
        return `Auction Completed`;
      case "Rejected":
        return `Auction Rejected`;
      default:
        return true;
    }
  };
  return (
    <Row>
      {data?.length > 0 ? (
        data?.map((card, index) => {
          const isPending = type === "pending-invites";
          return (
            <Col key={index} md={4}>
              <div className="promotion_card">
                {/* {card.live && (
                  <div className="status live">
                    <LiveIcon /> Live
                  </div>
                )} */}
                <div className="promotion_card_thumbnail">
                  {card.exclusive && (
                    <div className="exclusive">
                      <ExclusiveIcon />
                    </div>
                  )}
                  {isPending && (
                    <span className="vip_icon">
                      <VipIcon />
                    </span>
                  )}
                  <div className="time_txt">
                    <p>
                      <CalenderIcon2 />
                      <span>
                        {showTimeFun(
                          card?.auctionStatus,
                          card?.auctionStatus === "Scheduled"
                            ? card?.auctionStartDate
                            : card?.auctionStatus === "InProgress"
                              ? card?.auctionEndDate
                              : ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="promotion_card_details">
                    <h4>{card.name}</h4>
                    <p>{card.artist}</p>
                  </div>
                  <img onClick={() => handleNavigate(card)} src={card.thumbnail} alt="promotion"  style={{cursor:"pointer"}}/>
                  {card.price && /* (card?.auctionStatus === "InProgress" || card?.auctionStatus === "Scheduled" ) && */ (
                    <div className="price_txt">
                      <p onClick={() => handleNavigate(card)}>({card.price})</p>
                    </div>
                  )}
                  {isPending && (
                    <div className="price_txt danger">
                      <p onClick={() => handleNavigate(card)}>
                        Pending Invitation
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          );
        })
      ) : (
        <p>No records Found</p>
      )}
    </Row>
  );
};
export default PromotionsCard;
